import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useForecastData } from "@/lib/hooks/admin/use-forecast-data";
import { ForecastChart } from "./forecast-chart";
import { SettingsControls } from "./settings-controls";
import { ForecastTable } from "./forecast-table";
import { AVAILABLE_YEARS } from "./constants";

export function MentorForecastingDashboard() {
  const {
    selectedYear,
    setSelectedYear,
    settings,
    updateSettings,
    expandedRows,
    toggleRowExpanded,
    isLoading,
    forecastData,
    chartData,
    actualData,
    actualDataByYear,
    teenForecast,
    mentorsLeaving,
    mentorsLeavingByYear,
    prevYearDecemberStaff,
    handleTeenForecastChange,
    handleMentorsLeavingChange,
    clearForecasts,
    currentMonth,
  } = useForecastData();

  return (
    <div className="m-6 space-y-6 pb-16">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold leading-7 text-black">
            Mentor Forecasting
            {isLoading && <span className="ml-2 text-sm font-normal text-gray-400">(Loading...)</span>}
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Plan mentor recruitment based on projected teen growth
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Select value={selectedYear.toString()} onValueChange={(v) => setSelectedYear(parseInt(v))}>
            <SelectTrigger className="w-[120px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {AVAILABLE_YEARS.map((year) => (
                <SelectItem key={year} value={year.toString()}>
                  {year}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <button
            onClick={clearForecasts}
            className="rounded border border-gray-300 px-3 py-2 text-sm text-gray-500 hover:bg-gray-100 hover:text-gray-700"
            title="Reset forecasts to actual values"
          >
            Clear Forecasts
          </button>
        </div>
      </div>

      {/* Chart */}
      <ForecastChart
        chartData={chartData}
        selectedYear={selectedYear}
        settings={settings}
      />

      {/* Settings Controls */}
      <SettingsControls settings={settings} updateSettings={updateSettings} />

      {/* Recruiting Forecast Table */}
      <ForecastTable
        forecastData={forecastData}
        actualData={actualData}
        actualDataByYear={actualDataByYear}
        teenForecast={teenForecast}
        mentorsLeaving={mentorsLeaving}
        mentorsLeavingByYear={mentorsLeavingByYear}
        settings={settings}
        selectedYear={selectedYear}
        currentMonth={currentMonth}
        expandedRows={expandedRows}
        prevYearDecemberStaff={prevYearDecemberStaff}
        onTeenForecastChange={handleTeenForecastChange}
        onMentorsLeavingChange={handleMentorsLeavingChange}
        onToggleRow={toggleRowExpanded}
      />
    </div>
  );
}
